import type { Config } from "tailwindcss"

import baseConfig from "@productlane/tailwind-config"

export default {
	corePlugins: {
		// we'll copy the relevant parts to not interfere with radix
		preflight: false,
	},
	content: [
		"index.html",
		"./src/**/*.{ts,tsx}",
		"!./src/**/*.test.{ts,tsx}",
		"../../packages/ui/src/**/*.{ts,tsx}",
	],
	presets: [baseConfig],
	theme: {
		extend: {
			screens: {},
		},
	},
	//to make the font 450 instead of 400 by default
	plugins: [
		function ({ addBase }: { addBase: (styles: Record<string, any>) => void }) {
			addBase({
				"*, ::before, ::after": {
					fontWeight: "inherit",
				},
				body: {
					fontWeight: 450,
				},
			})
		},
	],
	safelist: ["bg-amber-100", "dark:bg-amber-900"],
} satisfies Config
